module.exports = __webpack_public_path__ + "1793882494189/fonts/socicon.9a64ef9.ttf";